export default {
  oneshot: {
    value: 'oneshot',
    label: 'One shot',
  },
  recurring: {
    value: 'recurring',
    label: 'Recurring',
  },
};